/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_MenuInputs */

const en_gc_home_menu = /** @type {(inputs: Gc_Home_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle navigation`)
};

const zh_gc_home_menu = /** @type {(inputs: Gc_Home_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展开或收起导航`)
};

/**
* | output |
* | --- |
* | "Toggle navigation" |
*
* @param {Gc_Home_MenuInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_menu = /** @type {((inputs?: Gc_Home_MenuInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_MenuInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_menu(inputs)
	return zh_gc_home_menu(inputs)
});
export { gc_home_menu as "gc.home.menu" }